import React from 'react'
import {Phone, Mail, MapPin} from 'lucide-react'

export default function Contact() {
  return (
    <div className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Get in Touch
          </h2>
          <p className="text-xl text-gray-400">
            Reach out to discuss how we can help your organization achieve its project goals
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-8 text-center hover:border-cyan-500/50 transition">
            <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <Phone className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Phone</h3>
            <a href="tel:9199303059" className="text-cyan-400 hover:text-cyan-300 transition">
              (919) 930-3059
            </a>
          </div>

          <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-8 text-center hover:border-emerald-500/50 transition">
            <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <Mail className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Email</h3>
            <a href="mailto:Triangleprojectconsultants@gmail.com" className="text-emerald-400 hover:text-emerald-300 transition break-all">
              Triangleprojectconsultants@gmail.com
            </a>
          </div>

          <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-8 text-center hover:border-amber-500/50 transition">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <MapPin className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Location</h3>
            <p className="text-amber-400">
              Raleigh, NC
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
